import { render, staticRenderFns } from "./TodayMeetingCard.vue?vue&type=template&id=1937d173&scoped=true"
import script from "./TodayMeetingCard.vue?vue&type=script&lang=js"
export * from "./TodayMeetingCard.vue?vue&type=script&lang=js"
import style0 from "./TodayMeetingCard.vue?vue&type=style&index=0&id=1937d173&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1937d173",
  null
  
)

export default component.exports